import { appendIf } from '@btime/helpers'
import { every } from 'lodash'
import { useTranslation } from 'react-i18next'
import {
  useNonComplianceCompleteAction,
  useNonComplianceCreateActionPlanAction,
  useNonComplianceDetailsAction,
  useNonComplianceReopenAction,
  useOpenNonComplianceBulkEdit
} from './actions'

const useSingleActions = (item, opts) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []

  const details = useNonComplianceDetailsAction(item)
  const completeAction = useNonComplianceCompleteAction(item)
  const reopen = useNonComplianceReopenAction(item)
  const createActionPlan = useNonComplianceCreateActionPlanAction(item)

  return [
    ...appendIf(!hide.includes('seeDetails'), {
      value: t('details'),
      icon: 'BsSearch',
      onClick: details.click
    }),

    ...appendIf(completeAction.hasPermission, {
      value: t('markAsCompleted'),
      icon: 'BsCheckSquare',
      onClick: completeAction.click
    }),

    ...appendIf(reopen.hasPermission, {
      value: t('reopen'),
      icon: 'BsInboxFill',
      onClick: reopen.click
    }),

    ...appendIf(createActionPlan.hasPermission, {
      value: t('createActionPlan'),
      icon: 'BsBookmarkPlus',
      onClick: createActionPlan.click
    })
  ]
}

const useMultiActions = (items, _opts) => {
  const { t } = useTranslation('common')
  const openNonComplianceBulkEditModal = useOpenNonComplianceBulkEdit(items)
  return [
    {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: () => openNonComplianceBulkEditModal.click(items)
    }
  ]
}

const hasSameType = (selectNonCompliances = []) => {
  if (!selectNonCompliances.length) return false
  const first = selectNonCompliances[0]
  const sameType = every(selectNonCompliances, { question: { type: { name: first.question.type.name } } })

  return sameType
}

export const useNonComplianceActionsList = (item, selectNonCompliances = [], opts = {}) => {
  const ids = selectNonCompliances.map(selected => selected.id)
  const singleOptions = useSingleActions(item, opts)
  const multiOptions = useMultiActions(ids, opts)
  const isSameType = hasSameType(selectNonCompliances)
  const showSingleOptions = !ids || ids.length === 1
  return [showSingleOptions ? singleOptions : isSameType ? multiOptions : singleOptions, false]
}
